import { Link } from "react-router-dom";
import SocialHandles from "./SocialHandles";
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-6 w-full overflow-hidden">
      <div className="w-ful px-0 md:px-6 grid grid-cols-1 md:grid-cols-8 md:text-left gap-10 text-center">
        {/* Column 1: Brand & Description */}
        <div className="col-span-8 md:col-span-3">
          <h2 className="text-2xl font-bold text-yellow-400">Bliss Distro</h2>
          <p className="mt-2 text-gray-400">Your music across the world!</p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="col-span-8 md:col-span-5">
          <ul className="w-full flex flex-row flex-wrap justify-center md:justify-start gap-5 md:gap-10 ">
            <li>
              <Link to="/about" className="hover:text-yellow-600">
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-yellow-600">
                Contact
              </Link>
            </li>

            <li>
              <Link to="/terms-conditions" className="hover:text-yellow-600">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="hover:text-yellow-600">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/cookies-policy" className="hover:text-yellow-600">
                Cookies Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="mt-6 text-center text-gray-500 text-sm">
  
          <div className=" w-full flex justify-center space-x-4">
            <SocialHandles/>
          </div>
        &copy; {new Date().getFullYear()} Bliss Distro. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
